import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import SuccessOverlay from "../../UserComponents/overlays/SuccessOverlay.js";
import AllRulesModal from "../../UserComponents/modals/AllRulesModal.js";
import ErrorOverlay from "../../UserComponents/overlays/ErrorOverlay.js";
import { useSelector, useDispatch } from "react-redux";
import { GetAllRulesAction } from "../../redux/actions/game.actions.js";
import { isValidEmail } from "../../utils/helper.js";
import { createOppTeam } from "../../services/team.services.js";
import { useHistory } from "react-router-dom";

const initialState = {
    licensedTeam: "",
    teamName: "",
    teamNickName: "",
    teamOwner: "",
    coachName: "",
    coachCell: "",
    coachEmail: "",
    isConference: true,
};

const CreateOpponentTeam = (props) => {
    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);
    const operatorTeam = useSelector((state) => state.team.selectedTeam);
    const history = useHistory();

    const [visible, setVisible] = useState(false);
    const [visible2, setVisible2] = useState(false);
    const [initialStateForm, setInitialStateForm] = useState(initialState);
    const [selectedColor, setSelectedColor] = useState(null);
    const [displayPhone, setdisplayPhone] = useState("");
    const [isFocused, setIsFocused] = useState(false);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const toggleColor = () => {
        setVisible(!visible);
    };
    const toggleSuccessModal = () => {
        setVisible2(true);
        setTimeout(() => {
            props.navigation.goBack();
            setVisible2(false);
        }, 2500);
    };

    const handleFormChange = (name, value) => {
        setInitialStateForm((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    // useId
    useEffect(() => {
        dispatch(GetAllRulesAction(user?.token));
    }, []);
    useEffect(() => {
        if (operatorTeam?.teamId._id && user?._id) {
            handleFormChange("licensedTeam", operatorTeam?.teamId._id);
            handleFormChange("teamOwner", user._id);
        }
    }, [user, operatorTeam]);
    useEffect(() => {
        let phoneLength = initialStateForm.coachCell.length;
        let formattedNumber = "";

        if (phoneLength < 4) {
            // return initialStateForm.phone;
            formattedNumber = initialStateForm.coachCell;
        } else {
            if (phoneLength < 7) {
                formattedNumber = `(${initialStateForm.coachCell
                    .toString()
                    .slice(0, 3)}) ${initialStateForm.coachCell.toString().slice(3)}`;
            } else {
                formattedNumber = `(${initialStateForm.coachCell
                    .toString()
                    .slice(0, 3)}) ${initialStateForm.coachCell
                        .toString()
                        .slice(3, 6)}-${initialStateForm.coachCell.toString().slice(6, 12)}`;
            }
        }

        setdisplayPhone(formattedNumber);
    }, [initialStateForm.coachCell]);

    const handleCreate = async () => {
        let emailLength = initialStateForm.coachEmail.length;
        try {
            if (emailLength > 0 && !isValidEmail(initialStateForm.coachEmail)) {
                throw new Error("Invaid email format!");
            }
            setLoading(true);
            const response = await createOppTeam(initialStateForm, user?.token);
            toggleSuccessModal();
            history.push('/opponents')
        } catch (e) {
            setError(e);
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="containerCreateTeam">
            <ErrorOverlay
                visible={!!error}
                error={error}
                onBackdropPress={() => setError(null)}
            />

            <div className="headerCreateTeam">
                {/* <button className="back-btn" onClick={props.goBack}>
          &#8592; Back
        </button> */}
                <h2 className="headerTxt">ADD OPPONENT TEAM</h2>
            </div>

            <form className="createTeamForm" onSubmit={(e) => e.preventDefault()}>
                <div className="nameInputRowCreateTeam">
                    <label className="nameTxtCreateTeam">Team Name:</label>
                    <input
                        className="inputCreateTeam"
                        type="text"
                        placeholder="Enter team name"
                        value={initialStateForm.teamName}
                        onChange={(e) => handleFormChange("teamName", e.target.value)}
                    />
                </div>

                <div className="nameInputRowCreateTeam">
                    <label className="nameTxtCreateTeam">Nickname:</label>
                    <input
                        className="inputCreateTeam"
                        type="text"
                        placeholder="Enter team nickname"
                        value={initialStateForm.teamNickName}
                        onChange={(e) => handleFormChange("teamNickName", e.target.value)}
                    />
                </div>

                <div className="nameInputRowCreateTeam">
                    <label className="nameTxtCreateTeam">Coach Name:</label>
                    <input
                        className="inputCreateTeam"
                        type="text"
                        placeholder="Enter coach name"
                        value={initialStateForm.coachName}
                        onChange={(e) => handleFormChange("coachName", e.target.value)}
                    />
                </div>

                <div className="nameInputRowCreateTeam">
                    <label className="nameTxtCreateTeam">Coach Cell #:</label>
                    <input
                        className="inputCreateTeam"
                        type="text"
                        placeholder="Enter coach number"
                        value={isFocused ? initialStateForm.coachCell : displayPhone}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        onChange={(e) => handleFormChange("coachCell", e.target.value)}
                    />
                </div>

                <div className="nameInputRowCreateTeam">
                    <label className="nameTxtCreateTeam">Coach Email:</label>
                    <input
                        className="inputCreateTeam"
                        type="email"
                        placeholder="Enter coach email"
                        value={initialStateForm.coachEmail}
                        onChange={(e) => handleFormChange("coachEmail", e.target.value)}
                    />
                </div>
                <div className="nameInputRowCreateTeam">
                    <input
                        className="inputCreateTeam"
                        type="checkbox"
                        id="isConference"
                        checked={initialStateForm.isConference}
                        onChange={(e) => handleFormChange("isConference", e.target.checked)}
                    />
                    <label htmlFor="isConference" className="nameTxtCreateTeam" style={{marginLeft: '10px'}}>
                        Conference
                    </label>
                </div>


                <button
                    className="saveBtnCreateTeam"
                    onClick={handleCreate}
                    disabled={loading}
                >
                    {loading ? "Creating..." : "Create"}
                </button>
            </form>

            {visible2 && (
                <SuccessOverlay
                    isVisible={visible2}
                    message="Team has been added successfully!"
                    onClose={() => toggleSuccessModal(false)}
                />
            )}
        </div>
    );
};

export default CreateOpponentTeam;
